import { Position } from "@xyflow/react";
import { Typography } from "antd";
import { NODE_REGISTRY } from "components/CC/Nodes/node-config";
import { HttpNodeProps } from "components/CC/Nodes/node-types";
import { BaseNode } from "components/CC/Nodes/NodeBase/BaseNode";
import { HttpIcon } from "components/CC/Nodes/NodeIcons";
import { NodeType } from "components/CC/types/enums";
import { TransparentHandle } from "components/CC/UI/TransparentHandle";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

export const HttpNode = ({ id, data }: HttpNodeProps) => {
    const { t } = usePaldockTranslation("components.connection-creator");
    const formData = data?.formData as { method?: string } | undefined;
    const method = formData?.method;

    const label = (
        <span className="flex items-center gap-1">
            {method && (
                <span
                    className="px-1 border border-gray-400 rounded text-xs"
                    style={{ color: "#888" }}
                >
                    {method}
                </span>
            )}
            <Typography.Text className="text-sm font-medium">{t("nodes.http.title")}</Typography.Text>
        </span>
    );

    return (
        <div>
            <BaseNode id={id} data={data} color={NODE_REGISTRY[NodeType.Http].color} label={label}>
                <HttpIcon />
            </BaseNode>
            <TransparentHandle position={Position.Left} type="target" />
            <TransparentHandle position={Position.Right} type="source" />
        </div>
    );
};
